module.exports = __webpack_public_path__ + "static/media/ai.c2f29c4d.svg";